import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth';
import {
  getMessaging,
  type Messaging,
  isSupported as isMessagingSupported,
} from 'firebase/messaging';

// Exported because the messaging service worker needs it too: it is
// plain JS outside the bundle, cannot read `import.meta.env`, and must
// have the config synchronously at top-level evaluation, so `fcm.ts`
// puts this object on the worker's script URL (see there for why).
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

export const firebaseApp: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(firebaseApp);
// NOTE: Firebase Storage SDK intentionally NOT initialized here. Photo
// uploads use a signed-URL + direct PUT (see lib/api/photos.ts), so the
// ~80 KB firebase/storage chunk is never pulled into the bundle.

let _messaging: Messaging | null = null;
export async function getMessagingIfSupported(): Promise<Messaging | null> {
  if (_messaging) return _messaging;
  if (!(await isMessagingSupported())) return null;
  _messaging = getMessaging(firebaseApp);
  return _messaging;
}

if (useEmulator) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
}
